import axios from 'axios';

export const upgradeAccount = () => async () => {
	const res = await axios.post('/api/upgrade-trial-account');

	const { error } = res.data;

	if (!error) {
		return { error: false };
	}

	return { error: true };
};

export const cancelAccount =
	({ reasonForLeaving, issuesEncountered, howToGainBack }) =>
	async () => {
		const res = await axios.post('/api/cancel-account', {
			reasonForLeaving,
			issuesEncountered,
			howToGainBack,
		});

		const { error, paidUntil } = res.data;

		if (!error) {
			return { error: false, paidUntil };
		}

		return { error: true };
	};

export const reactivateAccount =
	({ address, region, city, paymentMethodId }) =>
	async () => {
		const res = await axios.post('/api/reactivate-account', {
			address,
			region,
			city,
			paymentMethodId,
		});

		const { error, message } = res.data;

		if (!error) {
			return { error: false };
		}

		return { error: true, message };
	};
